<template>
  <section class="catg-area pt-5">
    <div class="">
      <div class="row align-content-center" style="margin:auto">
        <!-- <h4 class="mb-5">設定メニュー</h4> -->
        <div class="col-sm-12 col-12 mb-4 p-0">
          <div class="navbar">
            <router-link
              v-for="link in navbarLinks"
              :key="link.path"
              :to="link.path"
              class="navbar-item"
              :class="{ active: isActiveLink(link) }"
              :style="{ width: navbarItemWidth }"
            >
              {{ link.label }}
            </router-link>
          </div>
        </div>
        <router-view></router-view>
      </div>
    </div>
  </section>
</template>

<script>
import ChangePassword from '@/components/auth/ChangePassword.vue';
//import Notification from '@/components/dashboard/applicants/Notification.vue';
// import OccupationOrder from '../components/dashboard/OccupationOrder.vue';
import OccupationList from '../components/dashboard/OccupationList.vue';
import { mapGetters, mapActions } from 'vuex';
export default {
  name: 'Setting',
  components: { ChangePassword /*, Notification*/, OccupationList },
  computed: {
    ...mapGetters({
      isReviewer: 'isCreateReviewUser',
      isAdmin: 'currentUserIsAdmin',
      currentUser: 'getCurrentUser',
    }),
    globalUser() {
      return true;
    },
    jdMatchingAuthority() {
      return this.currentUser && this.currentUser.jdMatchingAuthority;
    },
    navbarItemWidth() {
      return `${100 / this.navbarLinks.length}%`;
    },
    navbarLinks() {
      const links = [
        {
          path: '/setting/review-list',
          label: '確認依頼用リスト',
          show: this.isReviewer,
        },
        {
          path: '/setting/users',
          label: '管理画面利用アカウント追加・削除',
          show: this.isAdmin,
        },
        // { path: '/setting/occupation-list', label: '募集中の職種分類設定', show: this.isReviewer },
        // { path: '/setting/jd-status', label: 'JBM設定', show: this.jdMatchingAuthority},
        {
          path: '/setting/change-password',
          label: 'パスワード変更・その他',
          show: this.globalUser,
        },
      ];
      return links.filter((link) => link.show);
    },
  },
  methods: {
    ...mapActions({
      loadCurrentUser: 'loadCurrentUser',
    }),
    isCurrentRoute(path) {
      return this.$route.path === path;
    },
    isActiveLink(link) {
      const currentPath = this.$route.path;
      return currentPath.startsWith(link.path);
    },
  },
  async mounted() {
    this.changeBodyToWhite();
    await this.loadCurrentUser();
    // console.log(this.navbarLinks);
    // const firstLink = this.navbarLinks[0];
    // if(this.$route.path === '/setting'){
    //   this.$router.push(firstLink);
    // }
  },
};
</script>
<style scoped>
h4 {
  color: #617776;
  font-weight: bold;
}
.mt-4,
.my-4 {
  margin-top: 6.5rem !important;
}

.navbar {
  display: flex;
  justify-content: flex-start;
  padding: 0px !important;
  /* padding-left:10px !important; */
  border-bottom: 1px solid black;
  /* background-color: #f5f5f5; */
}

.navbar-item {
  /* margin-right: 10px; */
  color: #3c3c3c;
  text-decoration: none;
  font-weight: 600;
}
.navbar-item {
  /* width: 25%; */
  text-align: center;
}

.navbar-item:hover {
  border-bottom: 5px solid #036d6c;
  color: #036d6c;
}
.active {
  border-bottom: 5px solid #036d6c;
  color: #036d6c;
}
</style>
